export default "__VITE_ASSET__8c327226__"